<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Costos - Configuración</h4>
            <div class="small text-muted">Configuración del módulo</div>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer" no-body>
        <b-row>
          <b-col>
            <b-tabs v-model="tabIndex" card>

              <b-tab title="Precios" :title-link-class="linkClass(0)">
                <b-card-text>

                  <b-alert show variant="warning" v-if="!parameters.roundUp">
                    El redondeo de precios no está habilitado para este módulo.
                    Para activarlo, habilitá el parámetro correspondiente desde la administración del sistema.
                  </b-alert>

                  <template v-if="parameters.roundUp">
                    <b-row v-if="crud.form['ID1']">
                      <b-col md="3" sm="12">
                        <b-form-group
                          label="Múltiplo para el redondeo de precios de venta"
                          description="Define el múltiplo al que se redondean hacia arriba los precios finales de venta. Con 0 solo se eliminan los decimales. Ej: con base 500, un precio de $15.200 pasa a $15.500."
                        >
                          <b-form-select
                            v-model="crud.form.ID1.value_number"
                            :options="crud.form.ID1.value_number_opt"
                          ></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col md="12">
                        <b-button variant="dark" size="sm" @click="savePrecios()">Guardar</b-button>
                      </b-col>
                    </b-row>
                  </template>
                </b-card-text>
              </b-tab>

            </b-tabs>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>
        </b-row>
      </b-card>

    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Session from '@/handler/session'
  import Param from '@/config/parameters'

  export default {
    data: () => {
      return {
        access: {
          module_id: Modules.COSTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'configuration',
          elements: {}
        },
        parameters: {
          roundUp: Helper.hasParametersAccess(Param.P69),
        },
        crud: {
          form: {
            ID1: {
              id: 0,
              value_string: '',
              value_number: 0,
              value_boolean: false,
              value_number_opt: [
                { value: 0,    text: 'Sin múltiplo (elimina decimales)' },
                { value: 10,   text: '10' },
                { value: 50,   text: '50' },
                { value: 100,  text: '100' },
                { value: 500,  text: '500' },
                { value: 1000, text: '1.000' },
                { value: 5000, text: '5.000' },
              ]
            },
          },
        },
        tabIndex: 0,
      }
    },

    created () {
      Helper.hasAccessView(this.access)
    },

    mounted () {
      this.show()
    },

    methods: {
      linkClass(idx) {
        if (this.tabIndex === idx) {
          return ['bg-dark', 'text-light']
        } else {
          return ['bg-light', 'text-dark']
        }
      },

      show() {
        var result = serviceAPI.obtenerConfiguracion()

        result.then((response) => {
          var data = response.data

          data.forEach(element => {
            if (element.id == 1) {
              this.crud.form.ID1.id = element.id
              this.crud.form.ID1.value_number = parseInt(element.value_number)
            }
          })
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },

      savePrecios() {
        this.$bvModal.msgBoxConfirm('¿Guardar configuración?', {
          title: 'Guardar',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'GUARDAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show()

            var result = serviceAPI.saveConfiguracion(this.crud.form.ID1)

            result.then((response) => {
              loader.hide()
              this.show()
              this.$awn.success("Configuración guardada")
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
    }
  }
</script>
